<template>
  <nav
    class="navbar"
    role="navigation"
    aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item logo">
        <router-link :to="'/'">
          <span class="secundary-color">vanhoutte</span><span>jp</span>
        </router-link>
      </a>

      <a
        id="nav-toggle"
        :class="{ 'is-active' : showNav }"
        role="button"
        class="navbar-burger nav-toggle"
        @click="showNav = !showNav">
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </a>
    </div>
    <div
      id="nav-menu"
      :class="{ 'is-active' : showNav }"
      class="navbar-menu">
      <div class="navbar-item has-dropdown is-hoverable">
        <router-link
          :to="'/producten/'"
          class="navbar-link">
          {{ $t('Header.Products') }}
        </router-link>
        <div
          v-if="productCategories"
          class="navbar-dropdown">
          <router-link
            v-for="productCategory in productCategories.categories"
            :to="'/producten/'+ productCategory.id + '/' + productCategory.title[0].text"
            :key="productCategory.id"
            class="navbar-item">
            {{ productCategory.title[0].text }}
          </router-link>
        </div>
      </div>
      <router-link
        :to="'/about/'"
        class="navbar-item">
        {{ $t('Header.About') }}
      </router-link>
      <router-link
        :to="'/contact/'"
        class="navbar-item">
        {{ $t('Header.Contact') }}
      </router-link>
      <app-locale-changer />
    </div>
  </nav>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import appLocaleChanger from "@/components/LocaleChanger";

export default {
  name: "Header",
  components: {
    appLocaleChanger
  },
  data() {
    return {
      showNav: false
    };
  },
  computed: {
    ...mapGetters({
      currentLanguage: "getCurrentLanguage",
      productCategories: "getProductCategories"
    })
  },
  watch: {
    currentLanguage() {
      this.fetchProductCategories();
    }
  },
  created() {
    this.fetchProductCategories();
  },
  methods: {
    ...mapActions({
      fetchProductCategories: "fetchProductCategories"
    })
  }
};

</script>

<style scoped lang="scss">
@import "../assets/css/style.scss";

.navbar {
  font-family: Nunito;
}
.secundary-color,
a.navbar-item:hover,
a.navbar-item.is-active,
.navbar-link:hover,
.navbar-link.is-active {
  color: $secundary;
}

.logo {
  font-size: 48px;
  text-transform: uppercase;
  font-weight: 800;
}

.navbar-link::after {
  border-color: $secundary;
}

.navbar-burger {
    margin-top: 17px;
}
</style>
